package com.essntl.features.task.ui.alltasks

import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.task.domain.model.TaskFilterOptions
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.sharedtask.SharedTaskState

data class AllTasksState(
    val sharedTaskState: SharedTaskState = SharedTaskState(),
    val getAllTasks: PaginationState<TaskModel> = PaginationState(),
    val getAllOverDueTasks: State<List<TaskModel>> = State(),
    val getAllCategory: State<List<CategoryModel>> = State(),
    val getAllProfile: State<List<ProfileModel>> = State(),
    val filterOptions: TaskFilterOptions = TaskFilterOptions(),
    val updateTaskLoading: Set<String> = emptySet(),
    val updateTaskOwnerLoading: List<String> = emptyList(),
) {
    val isLoading: Boolean
        get() = getAllTasks.isLoading ||
            getAllOverDueTasks.isLoading

    val isFailure: Boolean
        get() = getAllTasks.isFailure ||
            getAllOverDueTasks.isFailure
}
